import { useState } from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/landing/Hero';
import CompanyView from './components/company/CompanyView';
import CandidateView from './components/candidate/CandidateView';

export type View = 'landing' | 'company' | 'candidate';

export default function App() {
  const [view, setView] = useState<View>('landing');

  return (
    <div className="min-h-screen flex flex-col">
      <Header currentView={view} onViewChange={setView} />
      <main className="flex-1">
        {view === 'landing' && <Hero onViewChange={setView} />}
        {view === 'company' && <CompanyView />}
        {view === 'candidate' && <CandidateView />}
      </main>
      <Footer />
    </div>
  );
}
